import { stringify } from 'qs';
import request from '../utils/request';

export async function query() {
  return request('v1/api/users');
}

export async function queryCurrent() {
  let params = {}
  params = Object.assign(params, {
    includes: 'model%,role.action'
  });
  return request(`v2/api/account/user/me?${stringify(params)}`);
}

export async function queryStore(params) {
  params = Object.assign(params, {
    includes: 'partner,total'
  });
  return request(`/partner/stores?${stringify(params)}`);
}
